import {
  AgentConfigDto,
  AgentDefaultScope,
  AgentType,
  isAgentDefaultForScope,
} from '@paladin-monorepo/common';

/**
 * Picks the default agent config for chat start flows.
 * Priority: flagged default for scope → fallback type → first agent without inquiry binding.
 */
export function pickDefaultAgentConfig(
  configs: AgentConfigDto[] | undefined,
  fallbackType: AgentType,
  scope: AgentDefaultScope,
): AgentConfigDto | null {
  if (!configs?.length) {
    return null;
  }

  const flagged = configs.find((c) => isAgentDefaultForScope(c, scope));
  if (flagged) {
    return flagged;
  }

  const fallback = configs.find((c) => c.agentType === fallbackType);
  if (fallback) {
    return fallback;
  }

  return configs.find((c) => !c.requiresInquiry) ?? null;
}

export function pickDefaultAgentType(
  configs: AgentConfigDto[] | undefined,
  fallbackType: AgentType,
  scope: AgentDefaultScope,
): AgentType {
  return pickDefaultAgentConfig(configs, fallbackType, scope)?.agentType ?? fallbackType;
}

export function agentDefaultScopeFromPickerMode(
  mode: 'inquirer' | 'supplier',
): AgentDefaultScope {
  return mode === 'supplier' ? AgentDefaultScope.Supplier : AgentDefaultScope.Inquirer;
}
